import React from 'react';
import { Building2, Paintbrush, Grid3x3, Leaf, Sparkles, Wrench } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/card';
import { propertyServices } from '../mock';

const iconMap = {
  Building2,
  Paintbrush,
  Grid3x3,
  Leaf,
  Sparkles,
  Wrench
};

const PropertyServices = () => {
  return (
    <section id="property-services" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Property Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Complete property care solutions to maintain and enhance your property value
          </p>
        </div>

        {/* Featured Property Services Image */}
        <div className="mb-12 rounded-2xl overflow-hidden shadow-xl">
          <img 
            src="https://customer-assets.emergentagent.com/job_gifted-beaver-1/artifacts/24xd10hu_F0AA2E97-5136-4504-8127-97746C704278.png" 
            alt="Greenwood Property Services"
            className="w-full h-64 object-cover"
          />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {propertyServices.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-gray-200 bg-white"
              >
                <CardHeader className="space-y-4">
                  <div className="w-14 h-14 bg-amber-100 rounded-xl flex items-center justify-center group-hover:bg-amber-800 transition-colors">
                    <IconComponent className="w-7 h-7 text-amber-800 group-hover:text-white transition-colors" />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-amber-800 transition-colors">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PropertyServices;
